import React from "react"
import topSwirl from "../img/element-swirl.svg"
import bottomSwirl from "../img/element-swirl-2.svg"
import { classNames } from "./utils"
import PreviewCompatibleImage from "./PreviewCompatibleImage"

const Quote = ({
  logo,
  logoWidthOverride,
  text,
  profileImage,
  author,
  className,
}) => (
  <div
    className={classNames(
      "quote",
      text.length > 140 ? "quote-long" : undefined,
      className
    )}
  >
    <img
      style={{ position: "absolute", top: 0, right: 0 }}
      src={topSwirl}
      alt=""
    />
    <img
      style={{ position: "absolute", bottom: 0, left: 0 }}
      src={bottomSwirl}
      alt=""
    />
    <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
      <div style={{ flex: 3 }}>
        {logo && (
          <PreviewCompatibleImage
            className="logo"
            imageInfo={{
              image: logo,
              alt: author.company,
            }}
            style={logoWidthOverride ? { width: logoWidthOverride } : undefined}
          />
        )}

        <p className="quote-content">{text}</p>

        <div className="author">
          {author.profileImage && (
            <PreviewCompatibleImage imageInfo={author.profileImage} />
          )}
          <div>
            <p className="author-name">{author.name}</p>
            <p className="author-bio">
              {author.jobTitle}
              {author.company && <span>, {author.company}</span>}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Quote
